import { themr } from 'react-css-themr';

import { TABS } from 'react-toolbox/lib/identifiers';
import { tabsFactory } from 'react-toolbox/lib/tabs/Tabs';
import TabContent from 'react-toolbox/lib/tabs/TabContent';
import theme from 'react-toolbox/lib/tabs/theme.scss';
import popOverFactory from 'common/components/core/popover/popOverFactory';

import { TabWithCard } from './TabWithCard';
import IconTabTheme from './IconTab.scss';

const applyTheme = Component => themr(TABS, theme)(Component);
const applyIconTabTheme = Component =>
    themr('IconTab', IconTabTheme)(Component);

const iconTabThemeFactory = Tab => applyIconTabTheme(Tab);

const DefaultTab = applyTheme(TabWithCard);
const DefaultTabContent = applyTheme(TabContent);

const IconTab = iconTabThemeFactory(DefaultTab);
const IconTabContent = iconTabThemeFactory(DefaultTabContent);

const DefaultIconTabs = applyTheme(tabsFactory(IconTab, IconTabContent));
const IconTabs = applyIconTabTheme(DefaultIconTabs);

const TabWithPopover = popOverFactory({ Component: DefaultTab });
const IconTabWithPopover = iconTabThemeFactory(TabWithPopover);

const DefaultIconTabsWithPopover = applyTheme(
    tabsFactory(IconTabWithPopover, IconTabContent)
);
const IconTabsWithPopover = applyIconTabTheme(DefaultIconTabsWithPopover);

export { IconTab, IconTabs, IconTabWithPopover, IconTabsWithPopover };
